// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteAiConversationMutation($input: DeleteAiConversationInput!) {
    deleteAiConversation(input: $input) {
      success
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
